import React from "react";
import { Avatar, List } from "antd";
import Typography from "antd/es/typography/Typography";

const { Title } = Typography;

const TopExperts = ({ topExperts }) => {
  if (!topExperts.length) {
    return <div className="dashboard-empty-state">No top experts yet.</div>;
  }

  return (
    <div className="dashboard-panel">
      <div className="dashboard-panel__header">
        <div className="dashboard-panel__header-copy">
          <span className="dashboard-panel__eyebrow">Leaderboard</span>
          <Title level={5}>Top Scored Experts</Title>
          <span className="dashboard-panel__subtext">
            Surface high-performing expert profiles that deserve attention.
          </span>
        </div>
        <span className="dashboard-panel__metric">{topExperts.length}</span>
      </div>
      <List
        itemLayout="horizontal"
        dataSource={topExperts}
        className="dashboard-panel__list"
        renderItem={(expert) => (
          <List.Item>
            <List.Item.Meta
              avatar={
                <Avatar
                  src={
                    expert.image
                      ? expert.image
                      : `https://xsgames.co/randomusers/avatar.php?g=pixel&key=${expert.id}`
                  }
                />
              }
              title={
                <a href={`/admin/experts/${expert.id}`}>
                  {expert.name.toUpperCase()}
                </a>
              }
              description={
                <>
                  <div>{expert.title}</div>
                  <span className="dashboard-panel__pill">
                    Score {expert.score ?? 0}
                  </span>
                </>
              }
            />
          </List.Item>
        )}
      />
    </div>
  );
};

export default TopExperts;
